export default function hasError(
	errors: object,
	field: string,
	obj?: boolean,
): boolean {
	if (!obj) return {}.hasOwnProperty.call(errors, field);

	return true;
}
